import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css/navigation";

import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
const Ads = () => {
 
  const {announcements}=useSelector((state)=>state.HomeReducer);
  return (
    // <div className=' mt-lg-5 pt-lg-5'>
    //     <a href='/'>
    //         <img className='ads-image' src={image}/>
    //     </a>
    // </div>
    <div className="relative markets mt-lg-5 pt-lg-5  container" >
      {announcements.length>0&&(
        <Swiper
      modules={[Navigation, Pagination]}
      className="pb-2"
      spaceBetween={20}
      navigation={{
        prevEl: ".custom-prev",
        nextEl: ".custom-next",
      }}
      pagination={{ clickable: true }}
      slidesPerView={1}
    > 
      {announcements.map((announcement, index) => (
        <SwiperSlide key={index}>
            <Link to={`/announcement/${announcement.id}/${announcement.title}`}className=" flex justify-center items-center  h-72 bg-white rounded-2xl p-8">
              <img src={announcement.image}  style={{width:'100%',borderRadius:'10px',borderBottom:'5px solid #ac8856'}}/>
            </Link>
        </SwiperSlide>
      ))}
    </Swiper>
      )}
    

    </div>
  )
}

export default Ads
